// export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
// export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
// export const GET_PROJECTS_FAIL = 'GET_PROJECTS_FAIL';

export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
